import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import CameraIcon from '../../../Icons/Camera'
import Container from '../Container'

export interface CameraButtonProps {
    color?: string
    disabled?: boolean
    filled?: boolean
    shadow?: boolean
    size?: number
    title?: string
    onMouseEnter?: any
    onMouseLeave?: any
    onClick?: any
}

const CameraButton = memo((props: CameraButtonProps) => {
    const {
        color,
        size,
        filled,
        shadow,
        title,
        onMouseEnter,
        onMouseLeave,
        onClick,
        disabled,
    } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton
                data-testid="Container__CameraButton"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                disabled={disabled}
            >
                <CameraIcon
                    color={color ?? '#fff'}
                    filled={filled}
                    size={size}
                />
            </IconButton>
        </Container>
    )
})

export default CameraButton
